import React from 'react';
import { forgeClassHelper } from '../utils/classes';

const classes = forgeClassHelper('typeahead');

const HighlightedSuggestionText = (text, key) => (
  <span key={key} {...classes({ element: 'suggestion-fragment', modifier: 'highlight' })}>
    {text}
  </span>
);

export default HighlightedSuggestionText;
